import React, { useState, useEffect } from 'react';
import axios from 'axios';

function Customers() {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    address: '',
    type: 'retail',
    initial_purchased_quantity: '0'
  });

  useEffect(() => {
    fetchCustomers();
  }, []);

  const fetchCustomers = async () => {
    try {
      setLoading(true);
      const response = await axios.get('/api/customers');
      setCustomers(response.data);
    } catch (error) {
      console.error('Error fetching customers:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'initial_purchased_quantity' && !/^\d*$/.test(value)) {
      return;
    }
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post('/api/customers', formData);
      setFormData({
        name: '',
        phone: '',
        address: '',
        type: 'retail',
        initial_purchased_quantity: '0'
      });
      setShowForm(false);
      fetchCustomers();
    } catch (error) {
      console.error('Error adding customer:', error);
      alert(error.response?.data?.error || 'Lỗi khi thêm khách hàng');
    }
  };

  if (loading) {
    return <div className="loading">Đang tải khách hàng...</div>;
  }

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', gap: '12px', flexWrap: 'wrap' }}>
        <div>
          <h2>Quản Lý Khách Hàng</h2>
          <p>Theo dõi tổng số lượng mua tích lũy để áp bậc giá sỉ theo cấp khách hàng.</p>
        </div>
        <button className="success" onClick={() => setShowForm(true)}>+ Thêm khách hàng</button>
      </div>

      {showForm && (
        <div className="modal show">
          <div className="modal-content">
            <div className="modal-header">
              <h3 className="modal-title">Thêm khách hàng</h3>
              <button className="close-btn" onClick={() => setShowForm(false)}>×</button>
            </div>
            <form onSubmit={handleSubmit} className="modal-body">
              <div className="form-group">
                <label>Tên khách hàng</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label>Số điện thoại</label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label>Địa chỉ</label>
                <input
                  type="text"
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label>Loại khách hàng</label>
                <select name="type" value={formData.type} onChange={handleChange}>
                  <option value="retail">Bán lẻ</option>
                  <option value="wholesale">Bán sỉ</option>
                </select>
              </div>
              <div className="form-group">
                <label>Số sản phẩm đã mua ban đầu</label>
                <input
                  type="text"
                  inputMode="numeric"
                  name="initial_purchased_quantity"
                  value={formData.initial_purchased_quantity}
                  onChange={handleChange}
                />
              </div>
              <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                <button type="button" onClick={() => setShowForm(false)} style={{ background: '#999' }}>Hủy</button>
                <button type="submit">Thêm</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {customers.length === 0 ? (
        <div className="empty-state">Chưa có khách hàng nào</div>
      ) : (
        <div className="card">
          <table>
            <thead>
              <tr>
                <th>Tên</th>
                <th>Số điện thoại</th>
                <th>Địa chỉ</th>
                <th>Loại</th>
                <th>Mua ban đầu</th>
                <th>Tổng mua tích lũy</th>
              </tr>
            </thead>
            <tbody>
              {customers.map((customer) => (
                <tr key={customer.id}>
                  <td>{customer.name}</td>
                  <td>{customer.phone}</td>
                  <td>{customer.address}</td>
                  <td>{customer.type === 'wholesale' ? 'Bán sỉ' : 'Bán lẻ'}</td>
                  <td>{Number(customer.initial_purchased_quantity || 0).toLocaleString('vi-VN')} sản phẩm</td>
                  <td>{Number(customer.total_purchased_quantity || 0).toLocaleString('vi-VN')} sản phẩm</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default Customers;
